/** Default solid scrim when a course has no custom accent color. */
export const DEFAULT_COURSE_SCRIM_COLOR = "#0f2a1a";

export function courseScrimColor(accentColor?: string | null): string {
  return accentColor?.trim() || DEFAULT_COURSE_SCRIM_COLOR;
}
